// extracted by mini-css-extract-plugin
export var container = "_62-1";
export var editor = "_62-2";
export var resizable = "_62-3";
export var wrapper = "_62-0";